import { useEffect } from "react";

export default function OnBoarding() {
  return (
    <div className="main-onboard-conatainer">
      <div
        className="image-container"
        style={{
          alignItems: "center",
          justifyContent: "center",
          // cursor: "pointer",
        }}
        // onClick={() => (window.location.href = "/onboarding")}
      >
        <img src="/images/brave.png" alt="Brave Image" />
      </div>
    </div>
  );
}
